export function homePage(): string {
  return `
    <div class="min-h-screen">
      <!-- Hero Section -->
      <section class="container-wide py-16 sm:py-24" aria-labelledby="hero-heading">
        <div class="grid lg:grid-cols-5 gap-12 lg:gap-16 items-center">
          <div class="lg:col-span-3 anim-reveal">
            <span class="section-label">Portfolio</span>
            <h1 id="hero-heading" class="font-display font-extrabold text-display-xl mb-6" style="color: var(--text-primary)">
              Arthur<br>Miconnet
            </h1>
            <p class="font-display font-semibold text-display-md mb-6" style="color: var(--color-primary)">
              UX/UI Designer
            </p>
            <p class="font-body text-body-lg max-w-xl mb-10" style="color: var(--text-secondary)">
              26 ans, 4+ ans d'experience. Dynamique et curieux, je transforme la complexite
              metier en parcours simples. Recherche ciblee, prototypage rapide, mesure post-lancement.
            </p>
            <div class="flex flex-wrap gap-4">
              <a href="#projects" class="btn-primary">
                Voir mes projets
                <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                </svg>
              </a>
              <a href="mailto:arthur.miconnet1@gmail.com" class="btn-secondary">
                Me contacter
              </a>
            </div>
          </div>
          <div class="lg:col-span-2 flex justify-center anim-reveal-scale delay-2">
            <div class="w-56 h-56 sm:w-64 sm:h-64 rounded-3xl overflow-hidden anim-float" style="box-shadow: 0 20px 60px rgba(67, 56, 202, 0.12);">
              <img src="${document.querySelector('[data-asset="arthur"]')?.getAttribute('src') || ''}"
                   alt="Photo de Arthur Miconnet, UX/UI Designer"
                   class="w-full h-full object-cover"
                   loading="eager"
                   onerror="this.style.display='none'; this.parentElement.innerHTML='<div style=\\'background: var(--color-primary); width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; color: white; font-size: 3rem; font-weight: 700; font-family: Sora, sans-serif;\\'>AM</div>'">
            </div>
          </div>
        </div>
      </section>

      <div class="divider container-wide" role="separator"></div>

      <!-- About Section -->
      <section class="container-wide py-16 sm:py-20" aria-labelledby="about-heading">
        <div class="grid lg:grid-cols-2 gap-12 lg:gap-20">
          <!-- Formation -->
          <div class="anim-reveal">
            <span class="section-label">Formation</span>
            <h2 id="about-heading" class="section-title">Parcours</h2>
            <div class="space-y-6">
              <div class="timeline-item">
                <h3 class="font-display font-bold text-body-lg" style="color: var(--text-primary)">MBA Expert UX/UI Designer</h3>
                <p class="font-body text-body-md" style="color: var(--text-secondary)">MyDigitalSchool, Lyon</p>
                <p class="font-body text-body-sm" style="color: var(--text-tertiary)">2020 - 2023</p>
              </div>
              <div class="timeline-item">
                <h3 class="font-display font-bold text-body-lg" style="color: var(--text-primary)">BTS SIO</h3>
                <p class="font-body text-body-md" style="color: var(--text-secondary)">Formation HTML, CSS, PHP</p>
                <p class="font-body text-body-sm" style="color: var(--text-tertiary)">2017 - 2020</p>
              </div>
            </div>
          </div>

          <!-- Informations -->
          <div class="anim-reveal delay-2">
            <span class="section-label">Informations</span>
            <h2 class="section-title">Contact</h2>
            <ul class="space-y-4" role="list">
              <li>
                <a href="mailto:arthur.miconnet1@gmail.com" class="group flex items-center gap-4 font-body text-body-md py-2 transition-colors" style="color: var(--text-secondary)">
                  <span class="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors" style="background-color: rgba(67, 56, 202, 0.06);">
                    <svg class="w-5 h-5" style="color: var(--color-primary)" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                    </svg>
                  </span>
                  <span class="group-hover:underline">arthur.miconnet1@gmail.com</span>
                </a>
              </li>
              <li>
                <a href="tel:+33673208198" class="group flex items-center gap-4 font-body text-body-md py-2 transition-colors" style="color: var(--text-secondary)">
                  <span class="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style="background-color: rgba(67, 56, 202, 0.06);">
                    <svg class="w-5 h-5" style="color: var(--color-primary)" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                    </svg>
                  </span>
                  <span class="group-hover:underline">06 73 20 81 98</span>
                </a>
              </li>
              <li>
                <a href="https://am-dev.eu" target="_blank" rel="noopener noreferrer" class="group flex items-center gap-4 font-body text-body-md py-2 transition-colors" style="color: var(--text-secondary)" aria-label="Site web am-dev.eu (ouvre un nouvel onglet)">
                  <span class="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style="background-color: rgba(67, 56, 202, 0.06);">
                    <svg class="w-5 h-5" style="color: var(--color-primary)" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"></path>
                    </svg>
                  </span>
                  <span class="group-hover:underline">am-dev.eu</span>
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/in/arthur-miconnet" target="_blank" rel="noopener noreferrer" class="group flex items-center gap-4 font-body text-body-md py-2 transition-colors" style="color: var(--text-secondary)" aria-label="Profil LinkedIn d'Arthur Miconnet (ouvre un nouvel onglet)">
                  <span class="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style="background-color: rgba(67, 56, 202, 0.06);">
                    <svg class="w-5 h-5" style="color: var(--color-primary)" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"></path>
                    </svg>
                  </span>
                  <span class="group-hover:underline">@Arthur Miconnet</span>
                </a>
              </li>
              <li class="flex items-center gap-4 font-body text-body-md py-2" style="color: var(--text-secondary)">
                <span class="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style="background-color: rgba(67, 56, 202, 0.06);">
                  <svg class="w-5 h-5" style="color: var(--color-primary)" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"></path>
                  </svg>
                </span>
                <span>Anglais C1</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <div class="divider container-wide" role="separator"></div>

      <!-- Skills Section -->
      <section class="container-wide py-16 sm:py-20" aria-labelledby="skills-heading">
        <div class="text-center mb-12 anim-reveal">
          <span class="section-label">Expertise</span>
          <h2 id="skills-heading" class="section-title">Competences</h2>
        </div>
        <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <!-- Design UX/UI -->
          <div class="card p-8 anim-reveal delay-1">
            <div class="w-12 h-12 rounded-2xl flex items-center justify-center mb-5" style="background-color: rgba(67, 56, 202, 0.08);">
              <svg class="w-6 h-6" style="color: var(--color-primary)" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
              </svg>
            </div>
            <h3 class="font-display font-bold text-body-lg mb-3" style="color: var(--text-primary)">Design UX/UI</h3>
            <ul class="space-y-2 font-body text-body-md" style="color: var(--text-secondary)" role="list">
              <li>Recherche utilisateur</li>
              <li>Prototypage & tests</li>
              <li>Design system</li>
              <li>Accessibilite</li>
            </ul>
          </div>

          <!-- Developpement -->
          <div class="card p-8 anim-reveal delay-2">
            <div class="w-12 h-12 rounded-2xl flex items-center justify-center mb-5" style="background-color: rgba(67, 56, 202, 0.08);">
              <svg class="w-6 h-6" style="color: var(--color-primary)" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"></path>
              </svg>
            </div>
            <h3 class="font-display font-bold text-body-lg mb-3" style="color: var(--text-primary)">Developpement</h3>
            <ul class="space-y-2 font-body text-body-md" style="color: var(--text-secondary)" role="list">
              <li>SQL & dev</li>
              <li>HTML, CSS, PHP</li>
              <li>Integration responsive</li>
              <li>Azure DevOps</li>
            </ul>
          </div>

          <!-- Autres -->
          <div class="card p-8 anim-reveal delay-3">
            <div class="w-12 h-12 rounded-2xl flex items-center justify-center mb-5" style="background-color: rgba(67, 56, 202, 0.08);">
              <svg class="w-6 h-6" style="color: var(--color-primary)" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
              </svg>
            </div>
            <h3 class="font-display font-bold text-body-lg mb-3" style="color: var(--text-primary)">Autres</h3>
            <ul class="space-y-2 font-body text-body-md" style="color: var(--text-secondary)" role="list">
              <li>Marketing, SEO / SEA</li>
              <li>Methodologie de projet</li>
              <li>Figma, Adobe XD, Sketch</li>
              <li>Adobe Creative Suite</li>
            </ul>
          </div>
        </div>

        <!-- Qualites -->
        <div class="mt-12 text-center anim-reveal">
          <h3 class="font-display font-bold text-body-lg mb-6" style="color: var(--text-primary)">Qualites</h3>
          <div class="flex flex-wrap justify-center gap-3">
            <span class="tag !px-6 !py-3 !text-body-sm">Curieux</span>
            <span class="tag !px-6 !py-3 !text-body-sm">Rigoureux</span>
            <span class="tag !px-6 !py-3 !text-body-sm">Creatif</span>
            <span class="tag !px-6 !py-3 !text-body-sm">Dynamique</span>
          </div>
        </div>
      </section>

      <div class="divider container-wide" role="separator"></div>

      <!-- Experience Section -->
      <section class="container-wide py-16 sm:py-20" aria-labelledby="experience-heading">
        <div class="max-w-3xl mx-auto">
          <div class="mb-12 anim-reveal">
            <span class="section-label">Parcours</span>
            <h2 id="experience-heading" class="section-title">Experience</h2>
          </div>

          <div class="space-y-0">
            <!-- OKTEO -->
            <article class="timeline-item anim-reveal delay-1">
              <div class="flex flex-wrap justify-between items-start gap-2 mb-1">
                <h3 class="font-display font-bold text-body-lg" style="color: var(--text-primary)">UX/UI Designer</h3>
                <span class="tag !text-caption">2022 - 2025</span>
              </div>
              <p class="font-body font-medium text-body-sm mb-2" style="color: var(--color-primary)">OKTEO, Ceyzeriat</p>
              <p class="font-body text-body-md" style="color: var(--text-secondary)">
                Conception d'interfaces des solutions SaaS : recherche utilisateur, maquettes,
                design system et suivi des developpements dans Azure DevOps.
              </p>
            </article>

            <!-- Avenir Multimedia -->
            <article class="timeline-item anim-reveal delay-2">
              <div class="flex flex-wrap justify-between items-start gap-2 mb-1">
                <h3 class="font-display font-bold text-body-lg" style="color: var(--text-primary)">Integrateur Web</h3>
                <span class="tag !text-caption">2021 - 2022</span>
              </div>
              <p class="font-body font-medium text-body-sm mb-2" style="color: var(--color-primary)">Avenir Multimedia, Lyon</p>
              <p class="font-body text-body-md" style="color: var(--text-secondary)">
                Integration responsive, optimisation des performances et mise en ligne
                de sites vitrine et e-commerce.
              </p>
            </article>

            <!-- Wanimo -->
            <article class="timeline-item anim-reveal delay-3">
              <div class="flex flex-wrap justify-between items-start gap-2 mb-1">
                <h3 class="font-display font-bold text-body-lg" style="color: var(--text-primary)">Graphiste</h3>
                <span class="tag !text-caption">2020 - 2021</span>
              </div>
              <p class="font-body font-medium text-body-sm mb-2" style="color: var(--color-primary)">Wanimo, Lyon</p>
              <p class="font-body text-body-md" style="color: var(--text-secondary)">
                Creation de visuels web et print, declinaisons reseaux sociaux et
                participation a la refonte mobile du site.
              </p>
            </article>

            <!-- CREA2F -->
            <article class="timeline-item anim-reveal delay-4">
              <div class="flex flex-wrap justify-between items-start gap-2 mb-1">
                <h3 class="font-display font-bold text-body-lg" style="color: var(--text-primary)">Developpeur Web</h3>
                <span class="tag !text-caption">2018</span>
              </div>
              <p class="font-body font-medium text-body-sm mb-2" style="color: var(--color-primary)">CREA2F, Toulouse</p>
              <p class="font-body text-body-md" style="color: var(--text-secondary)">
                Developpement de modules intranet en PHP / Bootstrap et implementation
                d'un moteur de recherche interne.
              </p>
            </article>
          </div>
        </div>
      </section>

      <!-- CTA Section -->
      <section class="py-20 sm:py-28" style="background-color: var(--bg-subtle);" aria-labelledby="cta-heading">
        <div class="container-narrow text-center">
          <div class="anim-reveal">
            <span class="section-label">Collaboration</span>
            <h2 id="cta-heading" class="font-display font-bold text-display-lg mb-4" style="color: var(--text-primary)">
              Travaillons ensemble
            </h2>
            <p class="font-body text-body-lg mb-10 max-w-lg mx-auto" style="color: var(--text-secondary)">
              Vous avez un projet en tete ? Discutons-en !
            </p>
            <a href="mailto:arthur.miconnet1@gmail.com" class="btn-primary">
              <span>Me contacter</span>
              <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
              </svg>
            </a>
          </div>
        </div>
      </section>
    </div>
  `;
}
